// export const BASE_URL = 'http://localhost:8002/api/v1';
// export const BASE_URL = 'http://10.255.255.105:3020/api/v1';
export const BASE_URL = '/api/v1';
